"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = require("crypto");
const index_1 = require("./index");
function transformBody(body, order) {
    // we never want to order an array as it is deterministic in JSON
    if (Array.isArray(body) || typeof order !== 'function') {
        return body;
    }
    return order(body);
}
function hashBody(body, order) {
    const hash = (0, crypto_1.createHash)('md5');
    const jsonBody = JSON.stringify(transformBody(body, order));
    hash.update(jsonBody);
    return hash.digest('hex');
}
function generate(secret, algorithm = index_1.defaults.algorithm, unix, method, url, body, options) {
    const hmac = (0, crypto_1.createHmac)(algorithm, secret);
    hmac.update(typeof unix === 'number' ? unix.toString() : unix);
    hmac.update(method);
    hmac.update(url);
    if (typeof body === 'object' && body !== null) {
        hmac.update(hashBody(body, options === null || options === void 0 ? void 0 : options.order));
    }
    return hmac;
}
exports.default = generate;
